import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import {
  Button, Col, Row, Select,
} from 'antd';
import { Translation } from 'react-i18next';
import { PREFIX_FRONT_URL } from '../../consts';
import GooglePlay from '../../assets/imgs/GooglePlay.png';
import AppStore from '../../assets/imgs/appStore.png';

const { Option } = Select;

class FooterComponent extends Component {
  constructor(props) {
    super(props);
  }

  handleChange(lang) {
    window.changeLanguage(lang);
  }

  render() {
    return (
      <Translation>
        {(t) => {
          this.checkLanguage = window.localStorage.getItem('LANG') ? window.localStorage.getItem('LANG') : 'vi';
          return (
            <div className="footer-row">
              <Row gutter={32}>
                <Col span={6}>
                  <h3 className="footer__heading">{t('footer.about_us')}</h3>
                  <ul className="footer-list">
                    <li className="footer-item">
                      <Link to="" className="footer-item">{t('footer.more_info')}</Link>
                    </li>
                    <li className="footer-item">
                      <a href="https://blog.trustkeys.network" className="footer-item" rel="noreferrer" target="_blank">
                        {t('footer.blog')}
                      </a>
                    </li>
                    {/* <li className="footer-item"> */}
                    {/*  <Link to="" className="footer-item">{t('footer.community')}</Link> */}
                    {/* </li> */}
                  </ul>
                </Col>
                <Col span={6}>
                  <h3 className="footer__heading">{t('footer.product')}</h3>
                  <ul className="footer-list">
                    <li className="footer-item">
                      <a href="https://trustkeys.network" className="footer-item" target="_blank" rel="noreferrer">{t('footer.network')}</a>
                    </li>
                    <li className="footer-item">
                      <a href="https://butta.vn" className="footer-item" target="_blank" rel="noreferrer">{t('footer.social')}</a>
                    </li>
                    <li className="footer-item">
                      <a href="https://123xe.vn" className="footer-item" target="_blank" rel="noreferrer">123Xe</a>
                    </li>
                  </ul>
                </Col>
                <Col span={5}>
                  <h3 className="footer__heading">
                    {t('footer.community')}
                    {' '}
                  </h3>
                  <ul className="footer-list">
                    <li className="footer-item">
                      <a href="https://www.facebook.com/trustkeys.network" className="footer-item" target="_blank" rel="noreferrer">
                        Facebook
                      </a>
                    </li>
                    <li className="footer-item">
                      <Select
                        className="footer-item-select"
                        value={this.checkLanguage}
                        style={{ width: 120 }}
                        onChange={this.handleChange}
                      >
                        <Option value={window.c.VI}>{t('navigation.language_sub_vi_link')}</Option>
                        <Option value={window.c.EN}>{t('navigation.language_sub_en_link')}</Option>
                        {/* <Option value="Tiếng Hàn">Tiếng Hàn</Option> */}
                      </Select>
                    </li>
                  </ul>
                </Col>
                <Col span={7}>
                  <h2 className="footer_heading-app">{t('footer.download_here')}</h2>
                  <div className="footer__download">
                    <a href="https://apps.apple.com/app/id1462406645" target="_blank" rel="noreferrer">
                      <img src={AppStore} alt="AppPlay" className="footer__download-img" />
                    </a>
                    <a href="https://play.google.com/store/apps/details?id=com.trustkeysnetwork" target="_blank" rel="noreferrer">
                      <img src={GooglePlay} alt="GooglePlay" className="footer__download-google" />
                    </a>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col span={24}>
                  <div className="footer-row2">
                    <a href="https://trustkeys.network" style={{ color: 'white' }} rel="noreferrer" target="_blank">@TrustKeys 2020. trustkeys.network</a>
                  </div>
                </Col>
              </Row>
            </div>
          );
        }}
      </Translation>
    );
  }
}

export default FooterComponent;
